import type Taxon from "@/models/taxon";
import TaxonRepository from "@/repositories/taxonRepository";
import type { UsageOption } from "@/types";
import { arrayToObject, groupByArray } from "@/utils";
import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { useAuthStore } from "./auth";

export const useTaxaStore = defineStore("taxa", () => {
  const taxa = ref<Taxon[]>([]);
  const areTaxaLoaded = ref(false);

  const plants = computed<Taxon[]>(() => taxa.value.filter((taxon) => taxon.abstraction_level === "plant"));
  const varieties = computed<Taxon[]>(() => taxa.value.filter((taxon) => taxon.abstraction_level === "variety"));
  const taxaById = computed<Record<string, Taxon>>(() => arrayToObject(taxa.value, "id"));
  const taxaByUsage = computed<Record<string, Taxon[]>>(() => groupByArray(taxa.value, "usages"));
  const usages = computed<Set<UsageOption>>(() =>
    taxa.value.reduce((set, taxon) => {
      taxon.usages.forEach((usage) => set.add(usage));
      return set;
    }, new Set<UsageOption>())
  );

  async function getTaxa() {
    const auth = useAuthStore();
    if (!auth.isAuthenticated) return;
    areTaxaLoaded.value = false;
    taxa.value = await TaxonRepository.getAll();
    areTaxaLoaded.value = true;
  }

  return { taxa, areTaxaLoaded, plants, varieties, taxaById, taxaByUsage, usages, getTaxa };
});
